import orderBy from 'lodash.orderby';

import type { InvoiceAgreementLinkQuerySchema, InvoiceQuerySchema } from './schemas/invoices/invoice-query-schema';

/** Sort by agreement id, then first link whose agreement has parent_id=null (BE-safe parent pick). */
export function getParentAgreementLink(
  agreementLinks: InvoiceQuerySchema['agreement_links'] | null | undefined
): InvoiceAgreementLinkQuerySchema | null {
  const links = agreementLinks ?? [];
  const withAgreement = links.filter((link) => link.agreement != null);
  if (withAgreement.length === 0) {
    return null;
  }

  const sortedByAgreementId = orderBy(withAgreement, [(link) => link.agreement?.id ?? 0], ['asc']);
  const parentLink = sortedByAgreementId.find((link) => link.agreement?.parent_id == null);
  return parentLink ?? sortedByAgreementId[0] ?? null;
}
